module.exports = __webpack_public_path__ + "static/img/wifi.c08ffbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/wifi.png
// module id = Myi0
// module chunks = 1